import type { InsertUserGroupMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

type InsertUserGroupInput = {
  Name: string;
  Email?: string | null;
  Description?: string | null;
  OwnerContributor?: boolean;
};

const mapTrpcResponseToGraphQL = (trpcData: {
  Id: string;
}): InsertUserGroupMutation => ({
  insert_user_group_one: {
    __typename: 'user_group',
    Id: trpcData.Id,
  },
});

export const useInsertUserGroupTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.userGroup.insert.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.userGroup.userGroupsWithApprovers.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.userGroup.userGroupById.queryKey(),
        });
      },
    }),
  });

  return {
    insertUserGroup: async (
      variables: InsertUserGroupInput
    ): Promise<InsertUserGroupMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
